<template>
  <ButtonBase
    class="metamask-btn-large"
    @click="handleButtonClick"
    v-if="metamaskInstalled && props.isLargeButton"
  >
    <MetmaskIcon />Connect to Metamask
  </ButtonBase>
  <button
    class="metamask-btn"
    @click="handleButtonClick"
    v-else-if="metamaskInstalled"
  >
    <MetmaskIcon />
  </button>
</template>

<script setup>
import { onMounted, computed } from "vue";
import MetmaskIcon from "@/components/icons/Metamask.vue";
import * as EvmChains from "@/assets/data/evm_chains.json";
import ButtonBase from "@/components/ui/buttons/ButtonBase.vue";

const emit = defineEmits(["updateWallet"]);

const props = defineProps({
  evmChainId: {
    type: Number,
    required: true,
    default: 1,
  },
  isLargeButton: {
    type: Boolean,
    required: false,
    default: false
  }
});

const metamaskInstalled = computed(() => {
  return window?.ethereum?.isMetaMask;
});

const isMetamaskConnected = computed(() => {
  return metamaskInstalled.value && window.ethereum.selectedAddress !== null;
});

const handleAccountsChangedEvent = (metaMaskAccount) => {
  const metaMaskWalletAddresss = metaMaskAccount[0];
  emit("update-wallet", metaMaskWalletAddresss);
};

const requestMetaMaskAccount = () => {
  window.ethereum
    .request({ method: "eth_requestAccounts" })
    .then(handleAccountsChangedEvent)
    .catch((error) => {
      if (error.code === 4001) {
        // EIP-1193 userRejectedRequest error
        console.log("Please connect to MetaMask.");
      } else {
        console.error(error);
      }
    });
};

const getChainProfile = (chainId) => {
  const filteredChainProfile = EvmChains.default.filter((chain) => {
    return chain.chainId === parseInt(chainId, 16);
  });
  if (filteredChainProfile.length === 0) {
    return {};
  }
  const chainProfile = filteredChainProfile[0];
  chainProfile.chainId = `0x${chainProfile.chainId.toString(16)}`;
  return chainProfile;
};

const handleButtonClick = async () => {
  // Handle button click
  try {
    await window.ethereum
      .request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: props.evmChainId }],
      })
      .then(requestMetaMaskAccount);
  } catch ({ code }) {
    // This error code indicates that the chain has not been added to MetaMask.
    if (code === 4902) {
      try {
        const newChainProfile = getChainProfile(props.evmChainId);
        await window.ethereum
          .request({
            method: "wallet_addEthereumChain",
            params: [newChainProfile],
          })
          .then(requestMetaMaskAccount);
      } catch (defaultChainConnectionError) {
        // handle "add" error
        console.error(defaultChainConnectionError);
        console.error(
          "defaultChainConnectionError trying to connect to Ethereum Chain"
        );
      }
    }

    // internal error
    else if (code === -32602) {
      console.error("MetaMask invalid params provided");
    }

    // internal error
    else if (code === -32603) {
      console.error("MetaMask internal error, please reload the page");
    }
  }
};

</script>

<style lang="scss">
.metamask-btn {
  width: 6rem;
  aspect-ratio: 1 / 1;
  background: var(--input-background);
  border-radius: $border-radius;
  cursor: pointer;
  position: relative;
  border: 2px solid rgb(246, 133, 27, 0.25);
  transition: background 250ms;

  &:hover {
    background: #f6851b87;
  }

  &:active {
    background: rgb(255, 231, 208);
  }

  svg {
    width: 2.5rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.metamask-btn-large {
  background: var(--input-background);
  border-radius: $border-radius;
  cursor: pointer;
  position: relative;
  border: 2px solid rgb(246, 133, 27, 0.25);
  transition: background 250ms;
  background-color: #f6851b9e;

  &:hover {
    background: rgb(255, 231, 208);
  }

  svg {
    width: 2.5rem;
    position: absolute;
    top: 50%;
    left: 15%;
    transform: translate(-50%, -50%);
  }
}
</style>
